// ... (imports)
import React, { useState, useEffect } from 'react';
import './Login.css';
import { FiMail } from "react-icons/fi";
import { RiLockPasswordLine } from "react-icons/ri";
import { Link, useNavigate } from 'react-router-dom';
import Nav from '../../components/Navigation/Nav';
import bg from '../../assets/images/BG.png';
import homePageImage from '../../assets/images/Homepage_Image.jpg';

import Footer from '../../Pages/Footer/Footer';
import Landing from '../../Pages/Landing/Landing';

import { API_KEY, API_BASE_URL,BASE_URL } from '../../constants';
import { useAppContext } from '../../AppContext';
import {auth,provider} from "./config";
import {signInWithPopup,signInWithRedirect} from "firebase/auth";

import axios from 'axios';
import axiosInstance from './../../../src/axios'
import LoadingSpinner from './LoadingSpinner';

const Login = ({loading}) => {
    const { state, dispatch } = useAppContext();
    const navigate = useNavigate();
    const [data, setData] = useState({
        countryCode: '',
        mobileNumber: '',
        otp: '',
    });

    const [error, setError] = useState({});
    const [otpSent, setOtpSent] = useState(false);
    const [ user, setUser ] = useState('');
    const [GoogleVisibility,setGoogleVisibility]=useState(true)
    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Api-Key': API_KEY,
                },
                body: JSON.stringify({
                    country_code: data.countryCode,
                    mobile: data.mobileNumber,
                }),
            });

            if (response.ok) {
                console.log("response of sent otp")
                const responseData = await response.json();
                console.log(responseData)
                const OtpSentDetails={"OtpSentToMobile":responseData.data.mobile}
                localStorage.setItem("OtpSentDetails",JSON.stringify(OtpSentDetails));
                setOtpSent(true);
                setError({});
            } else {
                const errorData = await response.json();
                setError({ mobileNumber: errorData.message });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}verify-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Api-Key': API_KEY,
                },
                body: JSON.stringify({
                    country_code: data.countryCode,
                    mobile: data.mobileNumber,
                    otp: data.otp,
                }),
            });

            console.log(response)
            if (response.ok) {
                console.log(response.data)
                const responseData = await response.json();
                localStorage.setItem('userData', JSON.stringify(responseData.data));
                localStorage.setItem('accessToken',responseData.data.access);
                localStorage.setItem('refreshToken',responseData.data.refresh);
                axiosInstance.defaults.headers['Authorization']='JWT '+localStorage.getItem('accessToken');
                // Accessing member_id from the response data
                const member_id = responseData.data.user_profile.member_id;
                dispatch({ type: 'SET_MEMBER_ID', payload: member_id });
                // Constructing the navigation path using template literals
                navigate(`/webtree/${member_id}`);
            } else {
                const errorData = await response.json();
                setError({ otp: errorData.message });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleResendOtp = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Api-Key': API_KEY,
                },
                body: JSON.stringify({
                    country_code: data.countryCode,
                    mobile: data.mobileNumber,
                }),
            });

            if (response.ok) {
                setOtpSent(true);
                setError({});
            } else {
                const errorData = await response.json();    
                setError({ mobileNumber: errorData.message });
            }
            setGoogleVisibility(false)
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const loginUser=()=>
    {
        localStorage.setItem("googleLogin",true);
        signInWithRedirect(auth,provider);
    }

    return (
        <div>
             {loading ? (
        <LoadingSpinner message="Hang on!, we are logging you in to your account!"/>
      ) : (
            <div>
            <Nav />
            <div style={{ backgroundImage: `url(${homePageImage})` }}>
                <div className="container">
                    <div className="container-form">
                        {otpSent ? (
                            <form onSubmit={handleVerifyOtp}>
                                <h1>Verify OTP</h1>
                                <p>Please enter the 4-digit OTP sent to your mobile number.</p>
                                <div className="inputBox">
                                    <input
                                        type="text"
                                        name="otp"
                                        value={data.otp}
                                        onChange={handleChange}
                                        placeholder="Enter OTP"
                                    />
                                </div>
                                {error.otp && (
                                    <span style={{ color: "red", display: "block", marginTop: "5px" }}>
                                        {error.otp}
                                    </span>
                                )}
                                <br />
                                <button type="submit" className="loginBtn">
                                    VERIFY OTP
                                </button>
                                <br />
                                <br />

                                <a type="button" onClick={handleResendOtp}>
                                    Resend OTP
                                </a>
                                <br></br>
                                <div hidden={GoogleVisibility}>-------------- OR --------------</div>
                                <button type="button" class="login-with-google-btn" onClick={loginUser} hidden={GoogleVisibility}>Sign in with Google</button>        

                            </form>
                        ) : (
                            <form onSubmit={handleSendOtp}>
                                <h1>Login</h1>
                                <p>Please enter your country code and mobile number to receive OTP.</p>
                                <div className="inputBox">
                                    <input
                                        type="text"
                                        name="countryCode"
                                        value={data.countryCode}
                                        onChange={handleChange}
                                        placeholder="Country Code"
                                    />
                                </div>
                                <div className="inputBox">
                                    <FiMail className="mail" />
                                    <input
                                        type="text"
                                        name="mobileNumber"
                                        value={data.mobileNumber}
                                        onChange={handleChange}
                                        placeholder="Mobile Number"
                                    />
                                </div>
                                {error.mobileNumber && (
                                    <span style={{ color: "red", display: "block", marginTop: "5px" }}>
                                        {error.mobileNumber}
                                    </span>
                                )}
                                <br />
                                <button type="submit" className="loginBtn">
                                    SEND OTP
                                </button>
                                <br/>
                                <div>
                                
                                </div>
                            </form>
                        )}
                        <div><br /><br /></div>
                    </div>
                </div>
            </div>
            <Footer />
            </div>
      )}
        </div>
    );
};

export default Login;
